/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PatchApiV1ClassroomdisciplineIdFoldersReorder202,
  PatchApiV1ClassroomdisciplineIdFoldersReorder400,
  PatchApiV1ClassroomdisciplineIdFoldersReorder401,
  PatchApiV1ClassroomdisciplineIdFoldersReorder404,
  PatchApiV1ClassroomdisciplineIdFoldersReorderMutationRequest,
  PatchApiV1ClassroomdisciplineIdFoldersReorderMutationResponse,
  PatchApiV1ClassroomdisciplineIdFoldersReorderPathParams,
} from "../../types/classPlanningMaterialController/PatchApiV1ClassroomdisciplineIdFoldersReorder.ts";
import { reorderClassroomDisFoldersRequestViewModelSchema } from "../reorderClassroomDisFoldersRequestViewModelSchema.ts";

export const patchApiV1ClassroomdisciplineIdFoldersReorderPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<PatchApiV1ClassroomdisciplineIdFoldersReorderPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const patchApiV1ClassroomdisciplineIdFoldersReorder202Schema =
  z.any() as unknown as ToZod<PatchApiV1ClassroomdisciplineIdFoldersReorder202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const patchApiV1ClassroomdisciplineIdFoldersReorder400Schema =
  z.any() as unknown as ToZod<PatchApiV1ClassroomdisciplineIdFoldersReorder400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const patchApiV1ClassroomdisciplineIdFoldersReorder401Schema =
  z.any() as unknown as ToZod<PatchApiV1ClassroomdisciplineIdFoldersReorder401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const patchApiV1ClassroomdisciplineIdFoldersReorder404Schema =
  z.any() as unknown as ToZod<PatchApiV1ClassroomdisciplineIdFoldersReorder404>;

export const patchApiV1ClassroomdisciplineIdFoldersReorderMutationRequestSchema =
  z.lazy(
    () => reorderClassroomDisFoldersRequestViewModelSchema,
  ) as unknown as ToZod<PatchApiV1ClassroomdisciplineIdFoldersReorderMutationRequest>;

export const patchApiV1ClassroomdisciplineIdFoldersReorderMutationResponseSchema =
  z.lazy(
    () => patchApiV1ClassroomdisciplineIdFoldersReorder202Schema,
  ) as unknown as ToZod<PatchApiV1ClassroomdisciplineIdFoldersReorderMutationResponse>;
